import React, { useContext, useEffect, useState } from 'react'
import { checkRoleEvaluation, getTeamGoal, Goal } from '../../service/PerformanceAPI';
import SingleGoal from './SingleGoal';
import { UserContext } from '../../constant';
import { useNavigate } from 'react-router-dom';
import { encryptStorage } from '../../constant';

export default function EmployeeBlock({ role, progress, team, type, evaluationShow, individualGoal, index, evaluationId, goal }) {

    const user = useContext(UserContext)
    const navigate = useNavigate();



    const [customStartEvaluation, setcustomStartEvaluation] = useState(false);
    const [EvaluationId, setEvaluationId] = useState();
    const [empGoal, setEmpGoal] = useState([]);
    const [eachTeamGoal, SetEachTeamGoal] = useState([]);
    const [AllProgress, setAllProgress] = useState([]);
    let details = { role: '', roleId: '', week: 0, domain: '' };
    const [userDetails, setUserDetails] = useState(details);

    useEffect(() => {
        userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');
    }, [])

    useEffect(() => {
        if (evaluationId) setEvaluationId(evaluationId);
        setcustomStartEvaluation(user?.customStartEvaluation)
    }, [evaluationId, user?.customStartEvaluation])

    useEffect(() => {
        if (user?.empGoal) {
            
            setEmpGoal(user?.empGoal);
        }

    }, [user?.empGoal])

    const employeeGoals = async (empId) => {
        

        let goalData = {
            employeeId: empId,
            // evaluation_period_id: props.evaluationPeriodId,
            evaluation_period_id: EvaluationId,
            // domain: userDetails.domain,
        };
        let result = await Goal(goalData);

        setEmpGoal(result.data.ResponseData.individual);
    };

    const teamGoalId = async (id) => {
        let goalData =
            role == 'Manager' ? {
                teamGoalId: id,
                evaluation_period_id: EvaluationId,
                empId: userDetails.roleId
            } : {
                teamGoalId: id,
                // evaluation_period_id: props.evaluationPeriodId,
                evaluation_period_id: EvaluationId,

            };
        let result = await getTeamGoal(goalData);

        SetEachTeamGoal(result.data.ResponseData);
    };

    const EditGoal = async (id) => {
        navigate(`/goalform/${id}`);
    };

    const startEvaluation = async (empId) => {

        let role;
        if (encryptStorage.getItem('employeeId') === empId) {
            role = 'Team Member'
        }
        else {
            let checkrole = await checkRoleEvaluation({ viewerId: encryptStorage.getItem('employeeId'), empId: empId })
            if (checkrole.data.statusCode == 200) {
                role = checkrole.data.ResponseData === 'Manager' ? checkrole.data.ResponseData : 'Hr Manager'
            }
        }

        navigate('/performanceevaluation', {
            state: { empId: empId, evaluationPeriodId: EvaluationId, Domain: encryptStorage.getItem('department'), role: role },
        });
    };

    const bindIndividualGoal = () => {

        return (
            <div className="accordion-item border-0 my-2 mx-3 accordian-table-sty">
                <h2 className="accordion-header bg-white ps-3" id={individualGoal ? `${individualGoal.emp_id.replace(/\d/g, '').replace(/\d/g, '').replaceAll('-', '')}` : "individualgoal1"}>
                    <div className="d-flex">
                        <div className="d-block align-self-center">
                            <button
                                onClick={() => {
                                    employeeGoals(individualGoal.emp_id);
                                }}
                                className="accordion-button-custom border-0 collapsed white-bg pb-3 bold-text font-15 align-item-center" data-bs-toggle="collapse"
                                data-bs-target={individualGoal ? `#${individualGoal.emp_id.replace(/\d/g, '').replaceAll('-', '')}sub${index}` : "#individualgoalsub1"} aria-expanded="false"
                                aria-controls={individualGoal ? `${individualGoal.emp_id.replace(/\d/g, '').replaceAll('-', '')}sub${index}` : "individualgoalsub1"}>
                            </button>
                        </div>
                        <div className="d-block w-100 align-self-center">
                            <div className="row mx-0 pt-3 pb-3 border-none bg-white">
                                <div className="col-md-3">
                                    <div className="d-flex">
                                        <div className="d-block align-self-center">
                                            <img
                                                src="/Images/logo-person-user-person-icon.jpg"
                                                className="profile-pic"
                                                alt="creator-name"
                                            />
                                        </div>
                                        <div className="d-block align-self-center">
                                            <p className="ms-3 mb-0 gray-text font-15 medium-text">
                                                {individualGoal.emp_name}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 align-self-center">
                                    <h6 className="bold-text font-15">
                                        Team Member Evaluation
                                    </h6>
                                    {(
                                        individualGoal.length < 0 ? (
                                            <p className="mb-0 gray-text font-15 medium-text">
                                                Not Started
                                            </p>
                                        ) : (
                                            individualGoal?.employee_grand_rating !==
                                            undefined &&
                                            individualGoal?.employee_grand_rating !==
                                            '' &&
                                            individualGoal?.TeamMemberispublished !==
                                            '1'
                                        )
                                    ) ? (
                                        <>
                                            <img
                                                src={
                                                    !individualGoal?.employee_grand_rating
                                                        ? null : individualGoal?.employee_grand_rating.includes('+') ? `/Images/${individualGoal?.employee_grand_rating?.slice(0, -1)}_plus.png`
                                                            : individualGoal?.employee_grand_rating.includes('-') ? `/Images/${individualGoal?.employee_grand_rating?.slice(0, -1)}_minus.png` : null
                                                }
                                                className="emoji-sty"
                                                alt="excited-emoji"
                                                style={{ height: "25px", width: '25px' }}

                                            ></img>

                                            <span className="right-arrow font-18 tt-bold text-skyblue">
                                                {
                                                    individualGoal?.employee_grand_rating
                                                }
                                            </span>
                                        </>
                                    ) : (
                                        <p className="mb-0 gray-text font-15 medium-text">
                                            Not Started
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-2 align-self-center">
                                    <h6 className="bold-text font-15">
                                        Manager Evaluation
                                    </h6>
                                    {(
                                        individualGoal.length < 0 ? (
                                            <p className="mb-0 gray-text font-15 medium-text">
                                                Not Started
                                            </p>
                                        )
                                            :
                                            (
                                                individualGoal?.manager_grand_rating !== undefined &&
                                                individualGoal?.manager_grand_rating !== '' &&
                                                individualGoal?.Managerispublished !== '1'
                                            )
                                    ) ? (
                                        <>
                                            <img
                                                src={
                                                    !individualGoal?.manager_grand_rating
                                                        ? `` : individualGoal?.manager_grand_rating.includes('+') ? `/Images/${individualGoal?.manager_grand_rating?.slice(0, -1)}_plus.png`
                                                            : individualGoal?.manager_grand_rating.includes('-') ? `/Images/${individualGoal?.manager_grand_rating?.slice(0, -1)}_minus.png` : null
                                                }
                                                className="emoji-sty"
                                                alt="manager-emoji"
                                                style={{ height: "25px", width: '25px' }}

                                            ></img>

                                            <span className="right-arrow font-18 tt-bold text-skyblue">
                                                {individualGoal?.manager_grand_rating}
                                            </span>
                                        </>
                                    ) : individualGoal?.Managerispublished === '1' && role == 'Manager' ? (
                                        <p class="mb-0 text-yellow font-14 medium-text">
                                            Save as draft
                                        </p>
                                    ) : (
                                        <p className="mb-0 gray-text font-15 medium-text">
                                            Not Started
                                        </p>
                                    )}
                                </div>
                                <div className="col-md-2 align-self-center">
                                    <h6 className="bold-text font-15">
                                        HR Evaluation
                                    </h6>
                                    {(
                                        individualGoal.length < 0 ? (
                                            <p className="mb-0 gray-text font-15 medium-text">
                                                Not Started
                                            </p>
                                        ) : (
                                            individualGoal?.status ===
                                            undefined ||
                                            individualGoal?.status ===
                                            'pending' ||
                                            individualGoal?.status === ''
                                        )
                                    ) ? (
                                        <p className="mb-0 gray-text font-15 medium-text">
                                            Not Started
                                        </p>
                                    ) : individualGoal?.status ===
                                        'Rejected' ? (
                                        <p className="mb-0 text-red font-15 medium-text">
                                            Rejected
                                        </p>
                                    ) : individualGoal?.status ===
                                        'Approved' ? (
                                        <p className="mb-0 text-green font-15 medium-text">
                                            Approved
                                        </p>
                                    ) : null}
                                </div>
                                <div
                                    style={{ paddingBottom: "16px" }}
                                    onClick={() => {
                                        let check = customStartEvaluation ? startEvaluation(individualGoal.emp_id) : null;
                                        // startEvaluation(
                                        //     indGoal.emp_id
                                        // );
                                    }}
                                    className="col-md-2 align-self-center text-center"
                                >
                                    {
                                        individualGoal?.Managerispublished === '1' && role == 'Manager'
                                            ?
                                            <a className={customStartEvaluation ? " semibold-text font-15 text-decoration-none cursor" : "light-grayblue-text semibold-text font-15 text-decoration-none "}>
                                                Continue
                                                <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                            </a>
                                            :
                                            individualGoal?.status ===
                                                'Rejected' && role == 'Manager' ? <a className={customStartEvaluation ? " semibold-text font-15 text-decoration-none cursor" : "light-grayblue-text semibold-text font-15 text-decoration-none"}>
                                                Re-evaluate
                                                <img
                                                    src="/Images/right-arrow.svg"
                                                    className="right-arrow ps-2"
                                                />
                                            </a> :
                                                individualGoal?.status === 'Approved'
                                                    ? (
                                                        <a className={customStartEvaluation ? " semibold-text font-15 text-decoration-none cursor" : "light-grayblue-text semibold-text font-15 text-decoration-none "}>
                                                            View Evaluation
                                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                                        </a>

                                                    ) :
                                                    (individualGoal?.manager_grand_rating !== undefined &&
                                                        individualGoal?.manager_grand_rating !== '') &&
                                                        individualGoal?.employee_grand_rating !== undefined &&
                                                        individualGoal?.employee_grand_rating !== '' && role == 'Manager' ? (
                                                        <a className={customStartEvaluation ? " semibold-text font-15 text-decoration-none cursor" : "light-grayblue-text semibold-text font-15 text-decoration-none "}>
                                                            Edit
                                                            <img src="/Images/right-arrow.svg" className="right-arrow ps-2" />
                                                        </a>)
                                                        :
                                                        <a className={customStartEvaluation ? " semibold-text font-15 text-decoration-none cursor" : "light-grayblue-text semibold-text font-15 text-decoration-none"}>
                                                            Start Evaluation
                                                            <img
                                                                src="/Images/right-arrow.svg"
                                                                className="right-arrow ps-2"
                                                            />
                                                        </a>}
                                </div>
                            </div>
                        </div>
                    </div></h2>
                <div id={individualGoal ? `${individualGoal.emp_id.replace(/\d/g, '').replace(/[0-9]/g, '').replaceAll('-', '')}sub${index}` : "individualgoalsub1"} className="accordion-collapse bg-white collapse" aria-labelledby={individualGoal ? `${individualGoal.emp_id.replace(/[0-9]/g, '').replaceAll('-', '')}` : "individualgoal1"}>
                    <div className="accordion-body bg-white mx-3">
                        <ul className="list-unstyled">
                            {empGoal !== undefined ? empGoal?.map((res, i) => {
                                return (
                                    <SingleGoal role={role} type={'individual'} index={i} employeeGoals={employeeGoals} evaluationShow={evaluationShow} eachGoal={res} />
                                )
                            }) : null}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    const bindTeamGoal = () => {
        return (
            <div className="accordion-item border-0 my-2 accordian-table-sty">
                <h2 className="accordion-header bg-white ps-3" id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalmain${index}` : "teamgoalmain1"}>
                    <div className="d-flex">
                        <div className="d-block align-self-center">
                            <button onClick={() => {
                                teamGoalId(goal.id);
                            }}
                                className="accordion-button-custom bg-white collapsed border-0 goal-bg-color pb-3 bold-text font-15" type="button" data-bs-toggle="collapse"
                                data-bs-target={team ? `#${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalsub${index}` : "#teamgoalsub1"} aria-expanded="false" aria-controls={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalsub${index}` : "teamgoalsub1"}>
                            </button>
                        </div>
                        <div className="d-block w-100 align-self-center">
                            <div className=" mx-0 pt-3 pb-3 border-none bg-white d-flex justify-content-between border-none">
                                <div className="col-md-4 d-flex align-self-center">
                                    <div className="d-flex align-self-center">
                                        <a href="#" className="text-deco-none"><img src="Images/orange-arrow.svg" alt="orange-arrow" className="me-2 goal-icon" /></a>
                                    </div>
                                    <div className="d-flex align-self-center">
                                        <p className="font-15 mb-0 bold-text mygoal-para">
                                            {goal.goal_name}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-2 justify-content-center align-items-center text-center">
                                    <span className="right-arrow tt-bold font-15 text-skyblue">
                                        {goal.manager_rating != null ||
                                            goal.manager_rating != undefined ||
                                            goal.manager_rating != '' ? (
                                            <span className="right-arrow bold-text font-15 tt-bold text-skyblue">
                                                -
                                            </span>
                                        ) : (
                                            <>
                                                <img
                                                    src={
                                                        !goal?.manager_rating
                                                            ? null : goal?.manager_rating.includes('+') ? `/Images/${goal?.manager_rating?.slice(0, -1)}_plus.png`
                                                                : goal?.manager_rating.includes('-') ? `/Images/${goal?.manager_rating?.slice(0, -1)}_minus.png` : null
                                                    }
                                                    className="emoji-sty"
                                                    alt="excited-emoji"
                                                    style={{ height: "25px", width: '25px' }}
                                                ></img>
                                                <span className="right-arrow bold-text font-15 tt-bold text-skyblue">
                                                    {goal.manager_rating}
                                                </span>
                                            </>
                                        )}
                                    </span>
                                </div>
                                <div className="col-md-2 d-flex">
                                    <div className="d-flex align-self-center">
                                        <span className="semibold-text gray-text font-15 pe-2">
                                            {progress}%
                                        </span>
                                    </div>
                                    <div className="d-block progress progress-style align-self-center">
                                        <div
                                            className="progress-bar progress-style bg-info"
                                            role="progressbar"
                                            style={{
                                                width: `${progress}%`,
                                            }}
                                            aria-valuenow={50}
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 align-items-center d-flex justify-content-center">
                                    <span
                                        className={`status-btn ${goal.color} font-14`}
                                    >
                                        {goal.status}
                                    </span>
                                </div>
                                {goal.status == 'Completed' ? (
                                    <div className="dropend me-4 align-self-center">
                                    </div>
                                ) : (
                                    <div className="dropend me-4 align-self-center">
                                        <button
                                            type="button"
                                            className="btn p-0 align-self-center kebab-btn-sty"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span>
                                                <img
                                                    src="/Images/kebab-icon.svg"
                                                    className="kebab-size"
                                                />
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu optionboxsize shadow border-0">
                                            <li
                                                onClick={() => {
                                                    EditGoal(goal.id);
                                                }}
                                            >
                                                <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1">
                                                    <span>
                                                        <img
                                                            className="pe-2 mb-2"
                                                            src="/Images/pencil-icon.svg"
                                                        />
                                                    </span>
                                                    Edit
                                                </a>
                                            </li>
                                            <li
                                                data-bs-toggle="modal"
                                                data-bs-target={role === 'Manager' ? '#manager-Delete' : "#Org-Delete"}
                                                onClick={() => {
                                                    user?.setGoalId(goal.id)
                                                    user?.setTriggerEmpId(team)
                                                    user?.setTypeOfDelete("team")
                                                }}
                                            >
                                                <a className="dropdown-item dditems semibold-text fontcolor-1 fontsize12">
                                                    <span>
                                                        <img
                                                            className="pe-2"
                                                            src="/Images/delete-bin-icon.svg"
                                                        />
                                                    </span>
                                                    Delete
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </h2>
                <div id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalsub${index}` : "teamgoalsub1"} className="accordion-collapse collapse " aria-labelledby={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalmain${index}` : "teamgoalmain1"}>
                    <div className="accordion-body bg-white px-5">
                        <ul className="list-unstyled">
                            {eachTeamGoal !== undefined ? eachTeamGoal?.map((res, i) => {
                                return (
                                    <SingleGoal role={role} type={'team'} index={i} evaluationShow={evaluationShow} eachteamgoal={res} />
                                )
                            }) : null}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    return (
        type == 'individual' ? bindIndividualGoal() : bindTeamGoal()

    )

}
